import { harcamaKategorileri as DEFAULT_EXPENSE_CATEGORIES } from "../utils/constants";

const trUpper = (value = "") => String(value || "").toLocaleUpperCase("tr-TR");

const normalize = (value = "") => trUpper(value)
  .replace(/İ/g, "I")
  .replace(/İ/g, "I")
  .replace(/Ğ/g, "G")
  .replace(/Ü/g, "U")
  .replace(/Ş/g, "S")
  .replace(/Ö/g, "O")
  .replace(/Ç/g, "C")
  .replace(/[^A-Z0-9]+/g, " ")
  .replace(/\s+/g, " ")
  .trim();

const WORDS = {
  "Temizlik": [
    "DETERJAN", "YUMUSATICI", "YUMOŞ", "YUMOS", "OMO", "PERSIL", "RINSO", "ABC", "ARIEL", "ALO", "BINGO", "PEROS", "TURSIL", "CALGON", "FINISH", "FAIRY", "PRIL", "CIF", "DOMESTOS", "ACE", "ASPEROX", "MR MUSCLE", "KOSLA", "VANISH", "SILVER", "CAMASIR", "BULASIK", "YER TEMIZLEYICI", "YAG COZUCU", "KIREC COZUCU", "CAM TEMIZLEYICI", "WASH", "CLEAN", "TEMIZLEYICI", "SABUN", "SIVI SABUN", "KAGIT HAVLU", "TUVALET KAGIDI", "PECETE", "COP TORBASI", "SUNGIR", "SÜNGER", "ELDİVEN", "ELDIVEN", "PASPAS", "BEZ", "MIKROFIBER", "ISLAK MENDIL", "ISLAK HAVLU", "HIJYEN", "DEZENFEKTAN"
  ],
  "Kozmetik": [
    "SAMPUAN", "ŞAMPUAN", "DUS JELI", "DUŞ JELİ", "SAC KREMI", "SAÇ KREMİ", "DEODORANT", "ROLL ON", "PARFUM", "PARFÜM", "KREM", "LOSYON", "NIVEA", "DOVE", "ELIDOR", "PANTENE", "HEAD SHOULDERS", "HACI SAKIR", "HACI ŞAKIR", "COLGATE", "SENSODYNE", "DİŞ MACUNU", "DIS MACUNU", "DİŞ FIRÇASI", "DIS FIRCASI", "AGIZ BAKIM", "AĞIZ BAKIM", "RUJ", "MASKARA", "RIMEL", "FONDOTEN", "FONDÖTEN", "EYELINER", "OJE", "ASETON", "MAKYAJ", "PAMUK", "PED", "ORKID", "KOTEX", "GARNIER", "LOREAL", "L OREAL", "WATSONS", "GRATIS"
  ],
  "Bebek İhtiyaçları": [
    "BEBEK", "BEBE", "BEBEK BEZI", "BEBEK BEZİ", "PRIMA", "MOLFIX", "SLEEPY", "PAMPERS", "HUGGIES", "BABY", "MAMA", "APTAMIL", "HIPP", "BEBELAC", "HERO BABY", "BIBERON", "BİBERON", "EMZIK", "EMZİK", "PISIK", "PİŞİK", "BEBEK SAMPUAN", "BEBEK ŞAMPUAN", "ISLAK MENDIL", "ISLAK MENDİL", "SMA", "DEVAM SUTU", "DEVAM SÜTÜ"
  ],
  "İlaç": [
    "ECZANE", "ILAC", "İLAÇ", "PAROL", "MINOSET", "NUROFEN", "CALPOL", "DOLVEN", "AUGMENTIN", "AMOKLAVIN", "MAJEZIK", "APRANAX", "ARVELES", "DOLOREX", "VERMIDON", "ASPIRIN", "CORASPIRIN", "ANTIBIYOTIK", "ANTİBİYOTİK", "SURUP", "ŞURUP", "TABLET", "KAPSUL", "KAPSÜL", "DAMLA", "MERHEM", "VITAMIN", "VİTAMİN", "D VIT", "D VİT", "B12", "PROBIYOTIK", "PROBİYOTİK", "SERUM", "BURUN SPREY", "GAZ DAMLASI", "KATILIM PAYI", "FIYAT FARKI", "REÇETE", "RECETE"
  ],
  "Sağlık": [
    "HASTANE", "MUAYENE", "DOKTOR", "DİŞ", "DIS", "LABORATUVAR", "TAHLIL", "TAHLİL", "RONTGEN", "RÖNTGEN", "ULTRASON", "TANSIYON", "ATEŞ ÖLÇER", "ATES OLCER", "TERMOMETRE", "BAND", "YARA BANDI", "MASKE", "ALKOL", "BATIKON", "OKSIJEN", "OKSİJEN"
  ],
  "Giyim": [
    "TSHIRT", "T SHIRT", "TİŞÖRT", "TISORT", "GOMLEK", "GÖMLEK", "PANTOLON", "KAZAK", "HIRKA", "MONT", "CEKET", "ELBISE", "ELBİSE", "ETEK", "AYAKKABI", "TERLIK", "TERLİK", "CORAP", "ÇORAP", "IC GIYIM", "İÇ GİYİM", "SUTYEN", "KILOT", "LCW", "DEFACTO", "KOTON", "MAVI", "ZARA", "H M", "H&M", "BOYNER"
  ],
  "Ev İhtiyaçları": [
    "TABAK", "BARDAK", "TENCERE", "TAVA", "KASIK", "KAŞIK", "CATAL", "ÇATAL", "BICAK", "BIÇAK", "SAKLAMA KABI", "BORCAM", "SÜRAHI", "SURAHI", "HAVLU", "NEVRESIM", "NEVRESİM", "YASTIK", "YORGAN", "PERDE", "HALI", "AMPUL", "PIL", "PİL", "KABLO", "PRIZ", "PRİZ", "MUTFAK", "KASA POSETI", "KASA POŞETİ", "POSET", "POŞET", "FOLYO", "STREC", "STREÇ", "BUZDOLABI POSETI", "BUZDOLABI POŞETİ", "PISIRME KAGIDI", "PİŞİRME KAĞIDI"
  ],
  "Yemek": [
    "YEMEK", "PIDE", "PİDE", "LAHMACUN", "PIZZA", "PİZZA", "BURGER", "DÖNER", "DONER", "KEBAP", "TAVUK DUNYASI", "KÖFTE", "KOFTE", "CORBA", "ÇORBA", "MAKARNA", "PILAV", "PİLAV", "MENÜ", "MENU", "SANDVIC", "SANDVİÇ", "TOST", "KUMRU"
  ],
  "Kafe & Restoran": [
    "CAFE", "KAFE", "RESTAURANT", "RESTORAN", "STARBUCKS", "ESPRESSO", "LATTE", "CAPPUCCINO", "AMERICANO", "TURK KAHVESI", "TÜRK KAHVESİ", "KAHVE", "ÇAY", "CAY", "PASTA", "TATLI", "DONDURMA", "WAFFLE", "KURABIYE", "BROWNIE"
  ],
  "Oyuncak": [
    "OYUNCAK", "LEGO", "BARBIE", "PUZZLE", "TOP", "OYUN HAMURU", "BEBEK ARABA", "HOT WHEELS"
  ],
  "Market": [
    "MARKET", "MIGROS", "MİGROS", "BIM", "BİM", "A101", "SOK", "ŞOK", "CARREFOUR", "METRO", "MACRO", "FILE", "FİLE", "TARIM KREDI", "TARIM KREDİ", "ONUR", "KIM", "KİM", "HAKMAR", "GROSS", "SUT", "SÜT", "YOGURT", "YOĞURT", "AYRAN", "PEYNIR", "PEYNİR", "TEREYAG", "TEREYAĞ", "KASAR", "KAŞAR", "BEYAZ PEYNIR", "LABNE", "KREMA", "YUMURTA", "EKMEK", "BAZLAMA", "SIMIT", "SİMİT", "POGACA", "POĞAÇA", "TOST EK", "UN", "SEKER", "ŞEKER", "TUZ", "PIRINC", "PİRİNÇ", "BULGUR", "MAKARNA", "ERISTE", "ERİŞTE", "MERCIMEK", "MERCİMEK", "NOHUT", "FASULYE", "BARBUNYA", "YAG", "YAĞ", "ZEYTINYAG", "ZEYTİNYAĞ", "AYCICEK", "AYÇİÇEK", "SALCA", "SALÇA", "SOS", "KETCAP", "KETÇAP", "MAYONEZ", "RANCH", "HARDAL", "TURSULUK", "TURŞU", "KONSERVE", "TON BALIGI", "TON BALIĞI", "SARDALYA", "DOMATES", "SALATALIK", "BIBER", "BİBER", "PATATES", "SOGAN", "SOĞAN", "SARIMSAK", "HAVUC", "HAVUÇ", "KABAK", "PATLICAN", "PATLICAN", "MANTAR", "MARUL", "GOBEK", "GÖBEK", "ROKA", "MAYDANOZ", "DEREOTU", "NANE", "LIMON", "LİMON", "AVOKADO", "ELMA", "MUZ", "PORTAKAL", "MANDALINA", "UZUM", "ÜZÜM", "ARMUT", "CILEK", "ÇİLEK", "KARPUZ", "KAVUN", "KIVI", "KİVİ", "SEFTALI", "ŞEFTALİ", "KIRAZ", "ET", "TAVUK", "BALIK", "KIYMA", "KÖFTE", "KOFTE", "SUCUK", "SALAM", "SOSIS", "SOSİS", "PASTIRMA", "JAMBON", "ÇIKOLATA", "CIKOLATA", "BISKUVI", "BİSKÜVİ", "GOFRET", "KRAKER", "CIPS", "CİPS", "OREO", "ULKER", "ÜLKER", "ETI", "ETİ", "TORKU", "NESTLE", "MILKA", "DONDURMA", "CEKIRDEK", "ÇEKİRDEK", "FISTIK", "FISTIK", "BADEM", "CEVIZ", "CEVİZ", "FINDIK", "KAJU", "CEREZ", "ÇEREZ", "SU", "MADEN SUYU", "SODA", "KOLA", "FANTA", "SPRITE", "MEYVE SUYU", "ICE TEA", "FUSE TEA", "SCHWEPPES", "GAZOZ", "LIMONATA", "LİMONATA", "NESCAFE", "KAHVE", "CAY", "ÇAY", "KAKAO", "BAHARAT", "PUL BIBER", "KARABIBER", "KIMYON", "NANE", "TARÇIN", "TARCIN", "VANILIN", "KABARTMA", "PUDING", "PUDİNG", "HAMUR", "DONDURULMUS", "DONDURULMUŞ"
  ]
};

const CATEGORY_PRIORITY = [
  "İlaç", "Sağlık", "Bebek İhtiyaçları", "Temizlik", "Kozmetik", "Giyim", "Ev İhtiyaçları", "Oyuncak", "Kafe & Restoran", "Yemek", "Market"
];

const CATEGORY_ALIASES = {
  "Kisisel Bakim": "Kozmetik",
  "Kişisel Bakım": "Kozmetik",
  "Bebek": "Bebek İhtiyaçları",
  "Eczane": "İlaç",
  "Manav": "Market",
  "Kasap": "Market",
  "Şarküteri": "Market",
  "Sarkuteri": "Market",
  "Fırın": "Market",
  "Firin": "Market",
  "İçecek": "Market",
  "Icecek": "Market",
  "Atıştırmalık": "Market",
  "Atistirmalik": "Market",
  "Mutfak": "Ev İhtiyaçları"
};

function hasCategory(category, availableCategories) {
  return (availableCategories || DEFAULT_EXPENSE_CATEGORIES).includes(category);
}

function safeCategory(category, availableCategories) {
  const available = availableCategories || DEFAULT_EXPENSE_CATEGORIES;
  const aliased = CATEGORY_ALIASES[category] || category;
  if (available.includes(aliased)) return aliased;
  if (available.includes("Market")) return "Market";
  return available[0] || "Market";
}

function containsKeyword(normalizedName, keyword) {
  const normalizedKeyword = normalize(keyword);
  if (!normalizedKeyword) return false;
  return normalizedName.includes(normalizedKeyword);
}

export function detectReceiptCategory(productName, availableCategories = DEFAULT_EXPENSE_CATEGORIES) {
  const normalized = normalize(productName);
  if (!normalized) return safeCategory("Market", availableCategories);

  for (const category of CATEGORY_PRIORITY) {
    if (!hasCategory(category, availableCategories)) continue;
    const words = WORDS[category] || [];
    if (words.some((word) => containsKeyword(normalized, word))) {
      return safeCategory(category, availableCategories);
    }
  }

  if (/\b(?:ECZANE|ILAC|MUAYENE|KATILIM PAYI|FIYAT FARKI)\b/.test(normalized)) return safeCategory("İlaç", availableCategories);
  if (/\b(?:RESTORAN|RESTAURANT|CAFE|KAFE)\b/.test(normalized)) return safeCategory("Kafe & Restoran", availableCategories);

  return safeCategory("Market", availableCategories);
}

export function normalizeReceiptCategory(category, availableCategories = DEFAULT_EXPENSE_CATEGORIES) {
  const available = availableCategories || DEFAULT_EXPENSE_CATEGORIES;
  const raw = String(category || "").trim();
  if (available.includes(raw) && raw !== "Kredi Kartı") return raw;
  if (raw === "Kredi Kartı") return safeCategory("Market", available);
  return detectReceiptCategory(raw, available);
}

export function getReceiptCategoryOptions(availableCategories = DEFAULT_EXPENSE_CATEGORIES) {
  const preferred = ["Market", "Temizlik", "Kozmetik", "Bebek İhtiyaçları", "İlaç", "Sağlık", "Ev İhtiyaçları", "Giyim", "Yemek", "Kafe & Restoran", "Oyuncak", "Diğer Gider"];
  const available = availableCategories || DEFAULT_EXPENSE_CATEGORIES;
  const merged = [...preferred, ...available]
    .map((c) => safeCategory(c, available))
    .filter((c) => c && c !== "Kredi Kartı");
  return [...new Set(merged)];
}
